export default __webpack_public_path__ + "static/media/socket_01.41794ecf.jpg";